module.exports = __webpack_public_path__ + "assets/img/num-02-064c6a62.png";